import React from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import CustomerAddressCard from 'components/Customer/CustomerAddressCard';
import CustomerAddressesModal from 'components/Modals/CustomerAddressesModal';

import {
  openCustomerAddressesModal,
  closeCustomerAddressesModal
} from 'actions';

const CustomerAddresses = ({ addresses, modalTitle, moreButtonText, showActions }) => {
  const dispatch = useDispatch();
  const jurisdictions = useSelector(state => state.common?.jurisdictions ?? []);
  const modalShown = useSelector(state => state.customer?.isCustomerAddressesModalShown ?? false);

  const getPrimaryAddress = () => {
    const primaryAddresses = addresses?.filter(x => x.isPrimary);
    if (primaryAddresses && primaryAddresses.length > 0) {
      return primaryAddresses.sort((a, b) => b.source - a.source)[0];
    }
    return null;
  };

  const primaryAddress = getPrimaryAddress();

  const addressType = primaryAddress?.addressType ?? (addresses?.length > 0 && addresses[0].addressType);

  const showAddressModal = () => dispatch(openCustomerAddressesModal(addressType));
  const closeAddressModal = () => dispatch(closeCustomerAddressesModal());

  return (
    <React.Fragment>
      { (addresses == null || addresses.length === 0) && <p>N/A</p> }
      { addresses.length > 0 && <div className="customer-addresses">
        { primaryAddress && <CustomerAddressCard address={ primaryAddress } jurisdictions={ jurisdictions } /> }
        { addressType && addresses?.length > 1 && <button type="button" className="btn btn-link" onClick={ () => showAddressModal() }>{ moreButtonText }</button> }
      </div> }
      { addressType && modalShown === addressType && <CustomerAddressesModal
        title={ modalTitle }
        isShown={ modalShown === addressType }
        addresses={ addresses }
        showActions={ addressType === 2 && showActions }
        onConfirm={ () => closeAddressModal() }
      />}
    </React.Fragment>
  );
};

CustomerAddresses.propTypes = {
  addresses: PropTypes.arrayOf(PropTypes.shape),
  modalTitle: PropTypes.string,
  moreButtonText: PropTypes.string,
  showActions: PropTypes.bool
};

CustomerAddresses.defaultProps = {
  addresses: null,
  modalTitle: 'Customer Addresses',
  moreButtonText: 'Show More Addresses',
  showActions: false
};

export default CustomerAddresses;
